import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ISnListQueryParameters } from '@lib/api';
import { SnOperationalView, SnWidget } from '@lib/api/entities';
import { SnOperationalViewsAPI } from '@lib/api/services';
import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Component({
  selector: 'sn-op-widgets-list-view',
  templateUrl: './op-widgets-list-view.component.html',
  styleUrls: ['./op-widgets-list-view.component.scss'],
})
export class OpWidgetsListViewComponent implements OnInit, OnDestroy {
  public widgets: SnWidget[] = [];

  @Output() public readonly popout = new EventEmitter<SnWidget>();
  @Output() public readonly viewChange = new EventEmitter<void>();

  public selectedView: SnOperationalView;
  public isLoading: boolean = false;

  public form = new UntypedFormGroup({});
  public formModel: any = {};
  public formFields: SnFormFieldConfig[] = [
    {
      key: 'operationalViews',
      type: 'http-select',
      templateOptions: {
        label: t('navigation.operationalDashboards'),
        placeholder: t('dashboard.operational.widgets.selectDashboardPlaceholder'),
        search: true,
        valueProp: 'id',
        labelProp: 'name',
        infinityScroll: true,
        floatLabel: 'always',
        fetchDataFn: (params: ISnListQueryParameters) => {
          return this._operationalViewsAPI.getViewList(params);
        },
        change: (field, value) => {
          if (this.widgets?.length) {
            this.widgets.forEach((w) => (w.popout = false));
            this.widgets = [];
          }
          this.viewChange.next();
          this.selectedView = value;
          this._getWidgets(this.selectedView);
        },
      },
    },
  ];

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _operationalViewsAPI: SnOperationalViewsAPI,
    private readonly _toastrService: ToastrService,
  ) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onWidgetUpdated(widget: SnWidget): void {
    this._operationalViewsAPI
      .updateViewWidget(widget.operationalView, widget.id, widget)
      .pipe(takeUntil(this._destroy$))
      .subscribe();
  }

  public onPopout(widget: SnWidget): void {
    widget.popout = true;
    this.popout.next(widget);
  }

  private _getWidgets(view: SnOperationalView): void {
    this.isLoading = true;
    this._operationalViewsAPI
      .getViewWidgets(view.id)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          this.selectedView.widgets = response.results || [];
        },
        error: () => {
          this.isLoading = false;
          this._toastrService.error(t('dashboard.operational.errors.unableToLoadWidgets'));
        },
      });
  }
}
